import React, { useContext, useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { useNavigate } from "react-router-dom";

import css from "./AdminPage.module.css";
import { UserContext } from "../../context/UserContext";
import { Head } from "../../utils/Head";
import { MeetingCard } from "../../components/common/MeetingCard";
import { deleteMeeting } from "../../services/firebaseService";

export const AdminMeetings = () => {
  const { userData } = useContext(UserContext);
  const [meetings, setMeetings] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData?.id) return;

    const q = query(collection(db, "meetings"), orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => doc.data());
      setMeetings(list);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userData]);

  function handleOpenMeeting(meeting) {
    // Abrir a sala Jitsi em nova aba
    const jitsiURL = `https://meet.jit.si/${meeting.jitsiRoomName}`;
    window.open(jitsiURL, "_blank");
  }

  function deletePost(post) {
    let updatedList = [...meetings];
    updatedList = updatedList.filter((m) => m.id !== m.id);

    deleteMeeting(post.id);
    setShowDeleteModal(false);
    alert(post.title + " deleted");
  }

  return (
    <div className={css.container}>
      <Head title="Reuniões" description="Lista de reuniões - Ibhava" />

      <div className={css.header}>
        <h2>Minhas Reuniões</h2>
      </div>

      {loading && <p>Carregando reuniões...</p>}

      {!loading && meetings.length === 0 && (
        <p>Nenhuma reunião criada ainda.</p>
      )}

      <div className={css.meetingsList}>
        {meetings.map((m) => (
          <MeetingCard
            key={m.id}
            title={m.title}
            type={m.type}
            date={new Date(m.scheduleFor).toLocaleDateString("pt-BR", {
              weekday: "long",
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
            status={m.status}
            participants={m.participants}
          >
            <div className={css.actions}>
              <button
                onClick={() => handleOpenMeeting(m)}
                className="blueButton"
              >
                Abrir sala
              </button>
              <button
                className="greenButton"
                onClick={() => navigate(`/admin/meeting/${m.id}`)}
              >
                Ver detalhes
              </button>
              <button
                className="greenButton"
                onClick={() =>
                  navigate(`/admin/meeting/edit/${m.id}`, {
                    state: {
                      id: m?.id || "",
                      createdAt: m?.createdAt || "",
                      proId: m?.proId || "",
                      proName: m?.proName || "",
                      type: m?.type || "",
                      status: m?.status || "",
                      moderatorOnline: m?.moderatorOnline || "",
                      title: m?.title || "",
                      description: m?.description || "",
                      groupId: m?.groupId || "",
                      scheduleFor: m?.scheduleFor || "",
                      jitsiRoomName: m?.jitsiRoomName || "",
                      participants: m?.participants || [],
                      notes: m?.notes || "",
                      meetingUrl: m?.meetingUrl || "",
                    },
                  })
                }
              >
                Editar
              </button>
              <button
                className="redButton"
                onClick={() => setShowDeleteModal(m)}
              >
                Excluir
              </button>
            </div>
          </MeetingCard>
        ))}
      </div>
      {showDeleteModal && (
        <div className={css.modalOverlay}>
          <div className={css.modal}>
            <h3>Deletar Encontro</h3>
            <h4>{showDeleteModal.title}</h4>
            <div className={css.modalButtons}>
              <button
                type="submit"
                className="redButton"
                onClick={() => deletePost(showDeleteModal)}
              >
                Confirmar
              </button>
              <button
                type="button"
                className="defaultButton"
                onClick={() => {
                  setShowDeleteModal(false);
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
